export default "__VITE_ASSET__5ggpgFni__"